import { createContext, useContext } from 'react';
import type { SwimlaneProcessedRootProps } from '../types/swimlane';

/**
 * Context for storing and accessing Swimlane root props.
 *
 * The context provides access to the SwimlaneProcessedRootProps type, allowing deeply nested components
 * to access configuration without prop drilling, while maintaining type safety through TypeScript's structural typing.
 */
export const SwimlaneRootPropsContext = createContext<SwimlaneProcessedRootProps | undefined>(
  undefined,
);

export const useSwimlaneRootProps = () => {
  const context = useContext(SwimlaneRootPropsContext);
  if (context === undefined) {
    throw new Error('useSwimlaneRootProps must be used within a SwimlaneRootPropsContext provider');
  }
  return context;
};
